module.exports = __webpack_public_path__ + "static/media/md-trending-up.8ccacbe0.svg";